import * as actionTypes from './actionTypes';

/**
 * actions for fetching filters data
 */
export const updateSearchTermData = payload => {
  return {
    type: actionTypes.SET_SEARCH_TERM_DATA,
    payload,
  };
};
